<template>
  <layout title="Invoices">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 max-w-7xl w-full flex items-start">
        <sideMenu page="Invoices" />
        <div class="flex-1 md:ml-8 ml-4">
          <div
            class="
              font-black
              text-3xl text-gray-800
              inline-block
              lg:col-span-2
              col-span-1
            "
          >
            Invoices
          </div>
          <div
            class="
              mt-6
              bg-white
              shadow-allArround
              rounded-xl
              flex-1
              p-4
              text-gray-800
              overflow-hidden
            "
          >
            <tableVue
              :header="header"
              :row="row"
              emptyMessage="You don't have invoices. Subscribe to plan first."
              :loading="showLoading && showLoadingPlan"
            />
            <pagination class="mt-10" :data="invoices" @changePage="getInvoices" />
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/Layout/User/sideMenu.vue"
  );
const tableVue = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/table.vue");
const pagination = () =>
  import(
    /* webpackChunkName: "pagination" */ "../../Components/Layout/pagination.vue"
  );
export default {
  components: { layout, sideMenu, tableVue, pagination },
  data() {
    return {
      invoices: null,
      plan: null,
      showLoading: true,
      showLoadingPlan: true,
      row: [],
      header: [
        {
          title: "DATE OF INVOICE	",
        },
        {
          title: "PRICE",
          class: "text-right",
        },
        {
          title: "RECEIPT LINK",
          class: "text-right",
        },
      ],
    };
  },
  mounted() {
    this.getInvoices(1);
    this.axios
      .get("/user/api/plan")
      .then((response) => {
        if (response.data) {
          this.plan = response.data;
        }
        this.showLoadingPlan = false;
      })
      .catch(() => {
        this.showLoadingPlan = false;
      });
  },
  methods: {
    getInvoices(page) {
      this.axios
        .get("/user/api/invoices?page=" + page)
        .then((response) => {
          if (response.data) {
            this.invoices = response.data;
            this.setTableRow();
          }
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
        });
    },
    setTableRow() {
      this.row=[];
      let invoicesData = this.invoices.data;
      for (let i = 0; i < invoicesData.length; i++) {
        let invoice = invoicesData[i].invoices;
        for (let j = 0; j < invoice.length; j++) {
          let row = [
            {
              data: invoice[j].payout_date,
              type: "date",
            },
            {
              data: invoice[j].amount,
              currency: invoice[j].currency,
              type: "price",
              class: "text-right",
            },
            {
              data: `<a
                        href="${invoice[j].receipt_url}"
                        target="_blank"
                        rel="noreferrer"
                        class="mr-2 link"
                      >
                        Download
                      </a>`,
              class: "text-right",
            },
          ];

          this.row.push(row);
        }
      }
    },
  },
};
</script>